module.exports = __webpack_public_path__ + "img/Otp-guide-screen-1.3138acb8.png";